var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"JudgeRegionPager"},[_c(_vm.currentComponent,{tag:"component",on:{"currentView":_vm.changeComponent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }